
import { computed, defineComponent } from 'vue';
import { useIsMobile } from '@/composables/useIsMobile';

export default defineComponent({
  name: 'BaseDialog',
  props: {
    maxWidth: {
      type: [String, Number],
      required: true,
    },
    fullscreenOnMobile: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  setup(props, { emit }) {
    const { isMobile } = useIsMobile();
    const isFullscreen = computed(() => props.fullscreenOnMobile && isMobile.value);

    const handleClose = (value: boolean) => {
      if (!value) {
        emit('close');
      }
    };

    return {
      isFullscreen,
      handleClose,
      emit,
    };
  },
});
